var CryptoJS = require("crypto-js");
import asyncStorage from "@react-native-async-storage/async-storage";

const secret_key = "f21pj-0sdi3_Fxr5s-j7dl9";

const storage = {
  get: async () =>
    await asyncStorage.getItem("@auth").then((result) => {
      if (result) {
        var decryptedValue = CryptoJS.AES.decrypt(result, secret_key);
        var originalValue = decryptedValue.toString(CryptoJS.enc.Utf8);

        return JSON.parse(originalValue);
      } else {
        return null;
      }
    }),

  set: async (value: AuthDataT) => {
    const strValue = JSON.stringify(value);

    var encryptedValue = CryptoJS.AES.encrypt(strValue, secret_key).toString();

    await asyncStorage.setItem("@auth", encryptedValue);
  },

  remove: async () => await asyncStorage.removeItem("@auth"),
};

export default storage;
